export default __webpack_public_path__ + "static/media/second.ed2b5d7a.png";